export default __webpack_public_path__ + "static/media/stone_art.d672be5e.png";